import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import NumberFormat from 'react-number-format';
import { useParams } from 'react-router-dom';
import moment from 'utils/moment';
import styles from '../GrossReciept.module.scss';
import { renderInfoForType } from '../../../utils/helpers';
import { getGrossRecieptDetail } from '../redux/actions';
import HeaderBack from '../../../components/headerBack';
import SectionHeader from '../../../components/sectionHeader';
import icon from '../../../icons/Non_Airfield_WorkOrder.png';

const GrossRecieptDetails = ({ history }) => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.profile);
  const grossReceipts = useSelector(state => state.grossReciepts?.gross_receipts_detail);
  const [showDropDown, setShowDropDown] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(getGrossRecieptDetail(id));
    }
  }, [dispatch, id]);

  const handleDropDown = () => {
    setShowDropDown(prev => !prev);
  };

  const filterCategories = grossReceipts?.category_items
    ?.filter(obj => grossReceipts?.contract?.id.toString() === obj?.contract?.id?.toString()) || [];

  return (
    <>
    <SectionHeader icon={icon} translationID="shortcuts.lease.gross.recieptscccc" defaultTitle="Gross Receipts - Submission">
        <div className={styles.detailHeader}>
                <span
                    className={styles.actionDropBtn}
                    role="button" tabIndex={0}
                    onClick={() => handleDropDown()}
                    onKeyPress={() => handleDropDown()}
                  >
                    <FormattedMessage
                      id="workorders.detail.actionBtn"
                      defaultMessage="Actions"
                    />
                </span>
                {showDropDown
                  && (
                    <ul
                      className={`${styles.dropdown} ${
                        showDropDown ? styles.open : ''
                      }`}
                    >
                        <li className={styles.item}>
                        <span onClick={() => history.push(`/gross_receipts/${grossReceipts?.id}/edit`)}
                          onKeyPress={() => history.push(`/gross_receipts/${grossReceipts?.id}/edit`)}
                          role="button" tabIndex={0}>
                         Edit
                        </span>
                        </li>
                    </ul>
                )}
        </div>
    </SectionHeader>
      <div style={{ display: 'flex' }} className={styles.toolbar}>
      <HeaderBack
        translationID="inspections.new.prev"
        translationDefault="Back"
        backRoute={'/gross_receipts/list'}
      />
      </div>

      <div className={styles.DetailsWrapper} style={{ margin: '0px auto', padding: '40px' }}>
        <div className={styles.secondColumn} style={{ margin: '0px', maxWidth: '100%' }}>
          <div className={styles.billDetailsWrapper}>
            <div className={styles.billDetail1} />
            <div className={styles.billDetail2}>
              <div className={styles.invoiceNumber}>
                <div className={styles.invoiceDetailsTitle}>
                  <FormattedMessage
                    id="gross.detail.request.report_date"
                    defaultMessage="Report Date"
                  />
                  :
                </div>
                <div className={styles.invoiceDetailsTitle}>
                  <FormattedMessage
                    id="gross.detail.request.logged_by"
                    defaultMessage="Logged By"
                  />
                  :
                </div>
                <div className={styles.invoiceDetailsTitle}>
                  <FormattedMessage
                    id="gross.detail.request.time_period"
                    defaultMessage="Time Period"
                  />
                  :
                </div>
                <div className={styles.invoiceDetailsTitle}>
                          <FormattedMessage
                            id="gross.detail.receipts.Agreement"
                            defaultMessage="Agreement"
                          />
                          :
                </div>
              </div>
              <div className={styles.invoiceDate}>
                <div className={styles.invoiceDeatailsValue}>
                  {renderInfoForType(
                    { type: 'date' },
                    grossReceipts?.report_date,
                    null,
                    null
                  )}
                </div>
                <div className={styles.invoiceDeatailsValue}>
                  {grossReceipts?.logged_by?.fullname}
                </div>
                <div className={styles.invoiceDeatailsValue}>
                  {/* {'date'}                  */}
                  {`${grossReceipts?.month}-Q${grossReceipts?.quarter}-${moment(
                    grossReceipts?.year
                  ).format('YYYY')}`}
                </div>
                <div className={styles.invoiceDeatailsValue}>
                  {grossReceipts?.contract && grossReceipts?.contract?.contract_name}
                </div>
              </div>
            </div>
          </div>
          <table className={styles.table}>
                    <thead className={styles.tableHeader}>
                      <th>
                        <FormattedMessage
                          id="gross.detail.request.category"
                          defaultMessage="Category"
                        />
                      </th>
                      <th>
                        <FormattedMessage
                          id="gross.detail.request.glNumber"
                          defaultMessage="GL Number"
                        />
                      </th>
                      <th>
                        <FormattedMessage
                          id="gross.detail.request.gross.sales"
                          defaultMessage="Gross Sales"
                        />
                      </th>
                      <th>
                        <FormattedMessage
                          id="gross.detail.request.rate"
                          defaultMessage="Rate"
                        />
                      </th>
                      <th>
                        <FormattedMessage
                          id="gross.detail.request.rent"
                          defaultMessage="Percentage Rent"
                        />
                      </th>
                    </thead>
                    <tbody>
                      {filterCategories.map(item => (
                        <tr>
                          <td>{item.name}</td>
                          <td>{item?.gl_accounts?.gl_account_number}</td>
                          <td>
                            <NumberFormat
                              displayType="text"
                              value={item.gross_sales}
                              thousandSeparator
                              prefix={user.urls.currency || '$'}
                            />
                          </td>
                          <td>{`${item.rate}%`}</td>
                          <td>
                            <NumberFormat
                              displayType="text"
                              value={item.percentage_rent}
                              thousandSeparator
                              prefix={user.urls.currency || '$'}
                            />
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="6" rowSpan="3">
                          <div className={styles.itemsFooterWrapper}>
                            <div className={styles.itemsFooter}>
                              <div>
                                <p className={styles.totalTax}>
                                  <FormattedMessage
                                    id="lease.gross.receipts.total.gross.salesfff"
                                    defaultMessage="Total Gross Sales"
                                  />
                                </p>
                                <p className={styles.totalTax}>
                                  <FormattedMessage
                                    id="lease.gross.receipts.total.rent.duefff"
                                    defaultMessage="Total Rent Due"
                                  />
                                </p>
                                <p className={styles.totalTax}>
                                  <FormattedMessage
                                    id="lease.tenants.steps.step2.annual_guaranteefff"
                                    defaultMessage="Minimum Annual Guarantee"
                                  />
                                </p>
                                <p className={styles.totalTax}>
                                  <FormattedMessage
                                    id="lease.tenant.rent.balancefff"
                                    defaultMessage="Rent Balance"
                                  />
                                </p>
                              </div>
                              <div>
                                <p className={styles.totalTax}>
                                  <NumberFormat
                                    displayType="text"
                                    value={grossReceipts?.total_gross_sales}
                                    thousandSeparator
                                    decimalScale={user?.portal_airport?.airport_settings?.decimal_precision || 2}
                                    fixedDecimalScale
                                    prefix={user.urls.currency || '$'}
                                  />
                                </p>
                                <p className={styles.totalTax}>
                                  <NumberFormat
                                    displayType="text"
                                    value={grossReceipts?.total_rent_due}
                                    thousandSeparator
                                    decimalScale={user?.portal_airport?.airport_settings?.decimal_precision || 2}
                                    fixedDecimalScale
                                    prefix={user.urls.currency || '$'}
                                  />
                                </p>
                                <p className={styles.totalTax}>
                                  <NumberFormat
                                    displayType="text"
                                    value={grossReceipts?.min_annual_guarantee}
                                    thousandSeparator
                                    decimalScale={user?.portal_airport?.airport_settings?.decimal_precision || 2}
                                    fixedDecimalScale
                                    prefix={user.urls.currency || '$'}
                                  />
                                </p>
                                <p className={styles.totalTax}>
                                  <NumberFormat
                                    displayType="text"
                                    value={grossReceipts?.rent_balance}
                                    thousandSeparator
                                    decimalScale={user?.portal_airport?.airport_settings?.decimal_precision || 2}
                                    fixedDecimalScale
                                    prefix={user.urls.currency || '$'}
                                  />
                                </p>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
          </table>
          <div className={styles.summaryWrapper}>
          <div className={styles.itemsFooterWrapper}>
              <div>
                  <p className={styles.totalTax} style={{ fontWeight: 'bold' }}>
                  <FormattedMessage id="gross.detail.request.description" defaultMessage="Description" />
                  </p>
                  <p className={styles.invoiceDescription}>
                   {grossReceipts?.description === 'undefined' ? '' : grossReceipts?.description}
                  </p>
              </div>
          </div>
          </div>
         <div className={styles.summaryWrapper}>
         <div className={styles.itemsFooterWrapper}>
              <div className={styles.attachmentsWrapper}>
              <p className={styles.totalTax} style={{ fontWeight: 'bold' }}>
                  <FormattedMessage id="gross.detail.request.attachments" defaultMessage="Attachments" />
              </p>
              {Array.isArray(grossReceipts?.attachments) && grossReceipts.attachments.length > 0 && (
              <div className={styles.photos}>
                {grossReceipts?.attachments.map(e => (
                  <div key={e.name} className={styles.wrapper}>
                    <img src={e.preview || e.url} alt={e.name || e.file_name} />
                  </div>
                ))}
              </div>
              )}
              </div>
         </div>
         </div>
        </div>
      </div>
    </>
  );
};
GrossRecieptDetails.propTypes = {
  history: PropTypes.shape({}).isRequired
};

export default GrossRecieptDetails;
